"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIDialogCloseButton;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _Color = require("../core/Color");

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _colors = require("HubStyleTokens/colors");

var _UICloseButton = _interopRequireDefault(require("../button/UICloseButton"));

var getOffset = (0, _styledComponents.css)(["right:40px;top:40px;"]);

var getDetachedStyle = function getDetachedStyle(hovered, size) {
  return (0, _styledComponents.css)(["@media only screen and (min-width:50em){color:", ";position:absolute;", ";&::after{background:", ";}}"], hovered && _colors.MONOLITH, size === 'xl' && getOffset, (0, _Color.rgba)(_colors.OLAF, 0.1));
};

var CloseButton = (0, _styledComponents.default)(function (props) {
  var __detached = props.detached,
      rest = (0, _objectWithoutProperties2.default)(props, ["detached"]);
  return _react.default.createElement(_UICloseButton.default, rest);
}).withConfig({
  displayName: "UIDialogCloseButton__CloseButton",
  componentId: "g8p5p4-0"
})(["top:", ";", ";"], _sizes.MODAL_CLOSE_BUTTON_OFFSET, function (props) {
  return props.detached && getDetachedStyle(props.hovered, props.size);
});

function UIDialogCloseButton(props) {
  var className = props.className,
      detached = props.detached,
      size = props.size,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "detached", "size"]);
  var computedSize = detached && size == null ? 'xl' : size;
  return _react.default.createElement(_HoverProvider.default, props, function (hoverProviderProps) {
    return _react.default.createElement(CloseButton, Object.assign({
      className: (0, _classnames.default)("uiDialog-closeButton private-modal__control private-modal__close", className)
    }, rest, hoverProviderProps, {
      detached: detached,
      size: computedSize
    }));
  });
}

UIDialogCloseButton.propTypes = {
  detached: _propTypes.default.bool.isRequired,
  size: _UICloseButton.default.propTypes.size
};
UIDialogCloseButton.defaultProps = {
  detached: false
};
UIDialogCloseButton.displayName = 'UIDialogCloseButton';
module.exports = exports.default;